<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{$t('Practices')}}</h1>
          <h2 class="page-subtitle">{{ totalCount }} {{ totalCount === 1 ? $t('practice') : $t('practices')}}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TablePractice"
          identifier="B122TablePractice"
          get-b122-table-results-url="/practice/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('practice.emptyTitle').toString()"
          :empty-text="$t('practice.emptyText').toString()"
          initial-sort-by="number"
          :initial-sort-desc="false"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn">
          <template #cell(download)="row">
            <button class="ph-btn action-btn flex-row justify-content-center align-items-center"
                    @click="clickOnDownloadBtn(row.item.fileRobustagno.fileUrl)">
              <i class="ph-custom ph-download-fill"/>
            </button>
          </template>

          <template #cell(actions)="data">
            <div class="actions-container text-right" >
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(data)" v-if="allowEdit">
                <i class="ph-custom ph-pencil-simple-line-fill"/>
              </button>
            </div>
          </template>
        </b122-table>
      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api'
import B122Table from '../../components/b122/B122Table'
export default {

  name: 'PracticeIndex',

  components: {
    B122Table
  },

  data () {
    let isAuthorized = this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin
    return {
      totalCount: 0,
      allowCreate: isAuthorized,
      allowDelete: false,
      allowEdit: isAuthorized,
      selectedItem: null
    }
  },

  computed: {

    tableFields () {
      return [
        {
          label: '',
          key: 'download',
          sortable: false
        },
        {
          label: this.$i18n.t('Practice.number'),
          key: 'number',
          sortable: true
        },
        {
          label: this.$i18n.t('Practice.title'),
          key: 'title',
          sortable: true
        },
        {
          label:'',
          key: 'actions',
          sortable: false
        }
      ]
    }

  },

  methods: {

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'PracticeShow',
        params: {
          resourceId: row.item.id
        }
      })
    },

    async clickOnDownloadBtn (fileUrl) {
      const res = await api.get(fileUrl, {
        responseType: 'blob'
      })

      var disposition = res.headers['content-disposition'] || ''
      var filename = 'download'

      if (disposition) {
        var match = disposition.match(/filename="?([^"]+)"?/i)
        if (match && match[1]) {
          filename = match[1]
        }
      }

      var blobUrl = window.URL.createObjectURL(res.data)
      var a = document.createElement('a')
      a.href = blobUrl
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(blobUrl)
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'PracticeEdit',
        params: {
          practiceId: row.item.id
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/practice/PracticeIndex.vue